import {
  OktaAuth,
  OktaAuthOptions,
  urlParamsToObject,
} from "@okta/okta-auth-js";
import { useEffect, useState } from "react";
import { config } from "./config";

let oktaAuthSingleton: OktaAuth | null = null;

export async function createOktaAuthInstance() {
  if (oktaAuthSingleton) {
    return oktaAuthSingleton;
  }

  const { state } = urlParamsToObject(window?.location?.search ?? "") as {
    state: string;
  };

  const oktaAuthOptions: OktaAuthOptions = {
    ...config,
    state,
    pkce: true,
    responseType: "code",
  };

  const oktaAuth = new OktaAuth(oktaAuthOptions);

  await oktaAuth.start();

  oktaAuthSingleton = oktaAuth;

  return oktaAuthSingleton;
}

export function getOktaAuthInstance() {
  return oktaAuthSingleton;
}

export function useOktaAuthInitialization() {
  const [oktaAuth, setOktaAuth] = useState<OktaAuth | null>(null);

  useEffect(() => {
    createOktaAuthInstance().then((oktaAuth) => {
      setOktaAuth(oktaAuth);
    });
  }, []);

  return oktaAuth;
}

export function useOktaAuthInstance() {
  if (!oktaAuthSingleton) {
    throw new Error("Okta auth instance not found");
  }

  return oktaAuthSingleton;
}
